/* eslint-disable arrow-parens */
/* eslint-disable implicit-arrow-linebreak */

/**
 * The global state selectors
 */

import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectDashboard = state => state.dashboard || initialState

const makeSelectDashboard = () =>
  createSelector(
    selectDashboard,
    state => state
  )

export {
  selectDashboard,
  makeSelectDashboard
}
